
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiInfoReportProposal as ObiInfoReportProposalElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-info-report-proposal.js';
 
 
 

 
 export const ObiInfoReportProposal = createComponent({
   react: React,
   tagName: 'obi-info-report-proposal',
   elementClass: ObiInfoReportProposalElement,
   events: {
     
   }
  });
 
 